import { render, staticRenderFns } from "./FaqList.vue?vue&type=template&id=514e27d9&"
import script from "./FaqList.vue?vue&type=script&lang=ts&"
export * from "./FaqList.vue?vue&type=script&lang=ts&"
import style0 from "./FaqList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports